import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

export function useReportPowerConsumptionDaily() {
  const {
    electric: {
      power: {
        dailyConsumption: { yearStart, yearEnd, weekStart, weekEnd, dataPoint },
      },
    },
  } = useSelector(({ state }) => state);
  const { data = { ReportPowerConsumptionDaily: {} }, loading } = useQuery(GET_OVERVIEW, {
    variables: { yearStart, yearEnd, weekStart, weekEnd, dataPoint },
    skip: skip({ yearStart, yearEnd, weekStart, weekEnd, dataPoint }),
  });

  let { totalConsumption } = data.ReportPowerConsumptionDaily;
  return { loading, total: totalConsumption, data: data.ReportPowerConsumptionDaily.weeks || [] };
}

function skip(variables) {
  let skip = true;
  let { yearStart, yearEnd, weekStart, weekEnd, dataPoint } = variables;
  skip = ![yearStart, yearEnd, weekStart, weekEnd, dataPoint].every((v) => v);
  return skip;
}

const GET_OVERVIEW = gql`
  query ReportPowerConsumptionDaily(
    $yearStart: Int!
    $yearEnd: Int!
    $weekStart: Int!
    $weekEnd: Int!
    $dataPoint: String!
  ) {
    ReportPowerConsumptionDaily(
      yearStart: $yearStart
      yearEnd: $yearEnd
      weekStart: $weekStart
      weekEnd: $weekEnd
      dataPoint: $dataPoint
    ) {
      totalConsumption
      weeks {
        _id
        text
        color
        data {
          weekday
          value
        }
      }
    }
  }
`;
